var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":"primary","dark":"","width":"100%"}},[_c('v-card-text',[_vm._v("\n    "+_vm._s(_vm.mensaje)+"\n    "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }